/*eslint-disable */

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import { bus } from '@/main';
import toast from '@/services/toast';

// You need a specific loader for CSS files
Vue.component('multiselect', Multiselect)

export default {
  name: 'create-meeting-info-popup',
  components: {
    datetime: Datetime,
    Multiselect
  },
  props: [],
  data () {
    return {
      sentUserData:[],
      start_time:'',
      end_time:'',
      topic:'',
      users:'',
      userList:null,
      userListResults:[], 
      options:[],
      is_public:false,
      minDatetime:new Date().toISOString(),
      submitted:false
    }
  },
  computed: {

  },
  mounted () {
    if(this.thirtyDaysPopupState){
      this.thirtyDaysTrailState = true
    }
    if(localStorage.getItem('LoginedUserID')){
      this.sentUserData.push(localStorage.getItem('LoginedUserID'))
    }
    this.$store.dispatch('isConditionalListOfAllUsersFun').then((res) => {
      this.userList = res.data
      this.userListResults = this.userList.data
      if(this.userListResults.length == 0) return;
      for(var i = 0; i < this.userListResults.length; i++){
        this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
      }
    })
  },
  methods: {
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    closeCreateMeetingPopup(){
      bus.$emit('createMeetingPopupBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    updateEndTime() {
      if(this.start_time){
        const originalDate = this.start_time;
        const date = new Date(originalDate);
        date.setHours(date.getHours() + 1);
        const newDate = date.toISOString();
        this.end_time = newDate;
      }
    },
    createMeetingBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          for(var i = 0; i < this.users.length; i++){
            this.sentUserData.push(this.users[i].id)
          }
          let data = {
            topic:this.topic,
            start_time:this.start_time,
            end_time:this.end_time,
            users:this.sentUserData,
            is_public:this.is_public
          }
          this.$store.dispatch('createNewMeetingDetailsFun', data)
            .then((res) => {  
              toast.success(res.data.msg);
              this.submitted =  false
              this.getMeetingListAgain();
              this.closeCreateMeetingPopup();
            }).catch((err) => {
              toast.error(err.data.data.email || err.data.user_msg || err.data.msg);
              this.submitted =  false
            })
          return;
        }
      })
    },
    getMeetingListAgain(){
      this.$store.dispatch('getMeetingAllListFun')
    },
  }
}